exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1QfC-{position:relative;overflow:hidden}._1QfC->img,.y19oT{width:100%;height:100%}.y19oT{position:absolute;font-size:medium;top:0;left:0;background:#fff}", ""]);

// exports
exports.locals = {
	"container": "_1QfC-",
	"reload": "y19oT"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/components/common/BlurImg/index.css
// module id = 922
// module chunks = 2 3